'use strict';

angular.module('lingApp')
  .provider('RipContext', function (RipEnum) {
    var context = {};
    context.pendingRequestCount = 0;
    context.pendingRequestCompletionCount = 0;
    context.appInit = false;
    context.applicationMessage = null;
    context.i18nMap = {};

    context.set = function (appConfig, i18n) {
      _.extend(context, appConfig);
      _.extend(context, appConfig.l10nConstants);

      RipEnum.init([], i18n);

      context.appInit = true;
    };

    context.windRequest = function() {
      ++context.pendingRequestCount;
    };

    context.unwindRequest = function() {
      --context.pendingRequestCount;
    };

    context.windRequestCompletion = function() {
      ++context.pendingRequestCompletionCount;
    };

    context.unwindRequestCompletion = function() {
      --context.pendingRequestCompletionCount;
    };

    this.$get = function () {
      return context;
    };
  });
